var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit, QueryList, Renderer2, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { config } from '../../../../config/config';
import { VisitorCalendarActionCommand, VisitorSettingsCommand } from '../../../commands/pagination.query.command';
import { VisitorCreateEventCommand } from '../../../commands/visitor/event/create.event.command';
import { BaseComponent } from '../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../common/components/success.wrap/success.wrap.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { ModalService } from '../../../common/services/modal.service';
import { EventTimeService } from '../../../services/event.time.service';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AlertifyService } from '../../../services/alertify.service';
import { isNullOrUndefined } from '../../../common/extensions';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
var VisitorCreateEventComponent = /** @class */ (function (_super) {
    __extends(VisitorCreateEventComponent, _super);
    function VisitorCreateEventComponent(formBuilder, router, activatedRoute, modalService, imageService, alertify, visitorApiService, visitorCalendarStore, allFrontendSettingsStore, render, hubApiService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.visitorApiService = visitorApiService;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.render = render;
        _this.hubApiService = hubApiService;
        _this.resizeImageTemp = null;
        _this.timezoneLabel = '';
        _this.manualSetTimezone = false;
        _this.isLoadingTimezone = false;
        _this.hasSetTimezone = false;
        _this.isEmailGDPRAllowed = false;
        _this.lastTimezone = null;
        _this.command = new VisitorCreateEventCommand();
        _this.showTimezoneCitySelector = false;
        _this.frequencyItems = [];
        _this.frequencyEventTimes = [];
        _this.totalTimes = '';
        _this.dayInWeek = -1;
        _this.weekNo = -1;
        _this.submitSuccess = false;
        _this.isScrolledEnd = false;
        _this.isAllowOnlineEvents = true;
        _this.downwardArrow = config.downwardArrow;
        _this.visitorSettings = new VisitorSettingsCommand();
        _this.imageUploaderLabel2 = 'Please upload images in JPG, PNG or WEBP format. Landscape images recommended';
        _this.backUrl = routeConfigs.visitor.eventCalendar;
        _this.isImageChanged = false;
        _this.hasCopyrights = false;
        return _this;
    }
    Object.defineProperty(VisitorCreateEventComponent.prototype, "timeRangeControls", {
        get: function () {
            return this.createEventForm.get('timeRanges').controls;
        },
        enumerable: true,
        configurable: true
    });
    VisitorCreateEventComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.command.defaultImage = config.defaultImageUrl;
        this.createForm();
        this.command.frequency = 'custom';
        this.resetFrequencyDropdown();
        this.addTimeRange();
        this.command.timezone = EventTimeService.getTimezoneCode();
        this.setDefaultTimeValue();
        this.resetTimezoneLabel();
        // this.setImageUploaderLabel2();
        this.downwardArrow = this.imageService.imageSourceUrl(this.downwardArrow);
        this.render.listen(this.container.nativeElement, 'scroll', function () {
            if (!_this.container) {
                return false;
            }
            var _a = _this.container.nativeElement, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            _this.isScrolledEnd = scrollHeight - scrollTop === clientHeight;
        });
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            _this.frontendSettings = command;
            _this.isAllowOnlineEvents = _this.frontendSettings.customSettings.isAllowOnlineEvents;
        });
        // when going back, need to check where to back to, event calendar or trip planner
        // if from trip planner, the current url should be :hubName/submit-event
        this.activatedRoute.url.subscribe(function (data) {
            var submitPath = routeConfigs.submit.event.path.replace(':hubName/', '');
            if (data.any(function (x) { return x.path.includes(submitPath); })) {
                _this.backUrl = routeConfigs.tripPlanner.trip;
            }
        });
    };
    VisitorCreateEventComponent.prototype.descriptionChange = function () {
        this.descriptionArea.nativeElement.style.height =
            Math.min(this.descriptionArea.nativeElement.scrollHeight, 500) + 'px';
    };
    VisitorCreateEventComponent.prototype.virtualEventChange = function () {
        if (this.command.isOnlineEvent) {
            this.command.isHybridEvent = false;
        }
    };
    VisitorCreateEventComponent.prototype.onScroll = function ($event) {
    };
    VisitorCreateEventComponent.prototype.hybridEventChange = function () {
        if (this.command.isHybridEvent) {
            this.command.isOnlineEvent = false;
        }
    };
    VisitorCreateEventComponent.prototype.createForm = function () {
        this.createEventForm = this.formBuilder.group({
            name: [null, [Validators.required]],
            description: [null, []],
            category: [null, []],
            timeRanges: this.formBuilder.array([]),
            address: [null, []],
            host: [null, [Validators.required]],
            venue: [null, []],
            timezone: [null, []],
            hostLink: [null, []],
            eventLink: [null, []],
            organizerEmail: [null, []],
            ticketUri: [null, []],
        });
    };
    VisitorCreateEventComponent.prototype.setFrequencyDropdown = function () {
        if (this.command.eventTimes.length > 0) {
            this.setDefaultTimeValue();
        }
        this.frequencyItems = this.frequencyItems.filter(function (x) { return x.value !== 'last'; });
        var start = this.command.eventTimes[0].startTime;
        this.dayInWeek = EventTimeService.getDayOfWeek(start, this.command.timezone);
        var dayText = config.dayOfWeek[this.dayInWeek].name;
        var weekly = this.frequencyItems.first(function (x) { return x.value === 'weekly'; });
        if (weekly) {
            weekly.text = "Weekly on " + dayText;
        }
        var biWeekly = this.frequencyItems.first(function (x) { return x.value === 'biweekly'; });
        if (biWeekly) {
            biWeekly.text = "Every Other " + dayText + " (starts from " + EventTimeService.getDayAndMonth(start, this.command.timezone) + ")";
        }
        var monthly = this.frequencyItems.first(function (x) { return x.value === 'monthly'; });
        if (monthly) {
            var no = EventTimeService.getWeekDayNo(start, this.command.timezone);
            if (!no.isLast) {
                this.weekNo = no.no;
                monthly.text = "Monthly on the " + no.text + " " + dayText;
                monthly.value = 'monthly';
            }
            else if (no.isLast && no.text === 'last') {
                monthly.text = "Monthly on the last " + dayText;
                monthly.value = 'last';
            }
            else if (no.isLast && no.text !== 'last') {
                this.weekNo = no.no;
                monthly.text = "Monthly on the " + no.text + " " + dayText;
                monthly.value = 'monthly';
                this.frequencyItems.push({
                    value: 'last',
                    text: "Monthly on the last " + dayText,
                });
            }
        }
    };
    VisitorCreateEventComponent.prototype.frequencySourceChange = function (target) {
        var _this = this;
        this.command.frequency = target.value;
        var start = this.command.eventTimes[0].startTime;
        var end = this.command.eventTimes[0].endTime;
        // end = EventTimeService.addHours(new Date(end), -1);
        var eventTimes = [], days = [];
        var diff = 0;
        switch (target.value) {
            case 'daily':
                diff = EventTimeService.diff(start, end);
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonth(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonth(end, this.command.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setEventTimes(time.startTime, time.endTime, eventTimes);
                }
                break;
            case 'weekly':
                diff = EventTimeService.diff(start, end, 'weeks');
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * 7 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setEventTimes(time.startTime, time.endTime, eventTimes);
                }
                break;
            case 'biweekly':
                diff = EventTimeService.diff(start, end, 'biweekly');
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * 14 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setEventTimes(time.startTime, time.endTime, eventTimes);
                }
                break;
            case 'monthly':
                days = EventTimeService.getSameDayInWeek(start, end, this.dayInWeek, this.weekNo, this.command.timezone);
                this.totalTimes = days.length + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                days.forEach(function (x) {
                    var time = _this.adjustForDaylightSaving(start, end, x);
                    _this.setEventTimes(x, end, eventTimes);
                });
                break;
            case 'last':
                days = EventTimeService.getLastWeekDays(start, end, this.dayInWeek, this.command.timezone);
                this.totalTimes = days.length + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                days.forEach(function (x) {
                    var time = _this.adjustForDaylightSaving(start, end, x);
                    _this.setEventTimes(x, end, eventTimes);
                });
                break;
            default:
                break;
        }
        this.frequencyEventTimes = eventTimes;
    };
    VisitorCreateEventComponent.prototype.createEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var hubName, timesText, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if (!this.hasSetTimezone) {
                        if (!this.command.timezone) {
                            this.alertify.warning('Please set the timezone');
                            event.complete();
                            return [2 /*return*/];
                        }
                        this.submitSuccess = false;
                        hubName = this.allRouteParams.hubName;
                        this.command.isHubCreated = false;
                        timesText = [];
                        this.command.eventTimes.forEach(function (time) {
                            timesText.push({
                                startTimeText: EventTimeService.toNonTimezoneTimeText(time.startTime),
                                endTimeText: EventTimeService.toNonTimezoneTimeText(time.endTime),
                            });
                        });
                        this.command.eventTimesText = JSON.stringify(timesText);
                        if (!this.resizeImageTemp) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.resizeImageTemp)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            this.command.image = null;
                            this.command.imageLink = res.url;
                        }
                        _a.label = 2;
                    case 2:
                        this.visitorApiService
                            .createEvent(hubName, this.command, this.frequencyEventTimes)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.submitSuccess = true;
                            _this.command = new VisitorCreateEventCommand();
                            _this.createForm();
                            _this.command.frequency = 'custom';
                            _this.resetFrequencyDropdown();
                            _this.addTimeRange();
                            _this.setDefaultTimeValue();
                            _this.lastTimezone ? (_this.command.timezone = _this.lastTimezone) : _this.resetTimezoneLabel();
                            _this.descriptionArea.nativeElement.style.height = '40px';
                            _this.resizeImageTemp = null;
                            _this.isImageChanged = false;
                            _this.hasCopyrights = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    VisitorCreateEventComponent.prototype.onImageChange = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!file) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(file, config.compressImgWidth)];
                    case 1:
                        _a.resizeImageTemp = _b.sent();
                        this.isImageChanged = true;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VisitorCreateEventComponent.prototype.imageResized = function (imgBase64) {
        this.resizeImageTemp = imgBase64;
    };
    Object.defineProperty(VisitorCreateEventComponent.prototype, "isFormInvalid", {
        get: function () {
            var noTime = this.command.eventTimes.any(function (time) { return !time.startTime || !time.endTime; });
            // return this.createEventForm.invalid || !this.command.eventTimes || !this.command.eventTimes.length || noTime;
            return (this.createEventForm.invalid ||
                !this.command.eventTimes ||
                !this.command.eventTimes.length ||
                noTime ||
                (!this.command.isOnlineEvent && !this.command.address));
        },
        enumerable: true,
        configurable: true
    });
    VisitorCreateEventComponent.prototype.goBack = function () {
        this.visitorCalendarStore.actionCommand.next(new VisitorCalendarActionCommand());
        this.router.navigateByUrl(getRouteUrl(this.backUrl, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorCreateEventComponent.prototype.setEventTime = function (time, timeRange) {
        if (time.startTime) {
            timeRange.startTime = time.startTime;
        }
        if (time.endTime) {
            timeRange.endTime = time.endTime;
        }
        this.frequencySourceChange({ value: this.command.frequency });
    };
    VisitorCreateEventComponent.prototype.addTimeRange = function () {
        this.command.eventTimes.push({});
        // let timeRangeGroups = (<FormArray>this.createEventForm.get('timeRanges')).controls;
        // let getTimeRangeFunc = () => {
        //     let group = timeRangeGroups[this.command.eventTimes.length - 1];
        //     return group ? {start: group.get('startTime').value, end: group.get('endTime').value} : null;
        // };
        // let getOtherTimeRangesFunc = () => {
        //     let otherGroups = timeRangeGroups.slice(0, this.command.eventTimes.length - 1);
        //     return otherGroups.map(group => {
        //         return {start: group.get('startTime').value, end: group.get('endTime').value};
        //     });
        // };
        // let timeRangeValidator = timeRangeOverlapValidate(getTimeRangeFunc, getOtherTimeRangesFunc);
        // (<FormArray>this.createEventForm.get('timeRanges'))
        //     .push(this.formBuilder.group({
        //         startTime: [null, [Validators.required, timeRangeValidator]],
        //         endTime: [null, [Validators.required, timeRangeValidator]]
        //     }));
    };
    VisitorCreateEventComponent.prototype.removeTimeRange = function (i) {
        this.command.eventTimes.splice(i, 1);
        //(<FormArray>this.createEventForm.get('timeRanges')).removeAt(i);
    };
    VisitorCreateEventComponent.prototype.canDeactivate = function () {
        if (this.createEventForm.pristine) {
            return Observable.of(true);
        }
        var allowNavigate = new Subject();
        this.modalService.showUnSaveWarning({ allowNavigate: allowNavigate });
        return allowNavigate;
    };
    VisitorCreateEventComponent.prototype.resetTimezoneLabel = function () {
        // this.timezoneLabel = 'Timezone *(enter a city to set timezone)';
        var timezoneFormatterDefault = localStorage.getItem(localStorageKeys.timezoneFormatterDefault);
        if (timezoneFormatterDefault) {
            this.command.timezone = EventTimeService.getTimezoneCodeByFormatter(timezoneFormatterDefault);
        }
        else {
            this.command.timezone = EventTimeService.getTimezoneCode();
        }
        this.timezoneLabel = "Timezone (" + this.command.timezone + ")";
    };
    VisitorCreateEventComponent.prototype.citySelected = function () {
        var _this = this;
        if (this.timezoneAddress) {
            this.isLoadingTimezone = true;
            this.hubApiService
                .getTimezoneByLatlng(this.timezoneAddress.lat, this.timezoneAddress.lng)
                .finally(function () {
                _this.isLoadingTimezone = false;
            })
                .subscribe(function (data) {
                console.log(data);
                _this.command.timezone = data.abbreviation;
                _this.hasSetTimezone = true;
                _this.lastTimezone = _this.command.timezone;
                _this.timezoneLabel = "Timezone (" + _this.command.timezone + ")";
                _this.dateTimeInput.toArray().forEach(function (x) {
                    x.timeFormatter = EventTimeService.getTimezoneFormatterByTimezone(_this.command.timezone);
                    x.timezone = _this.command.timezone;
                    x.setTime('start');
                    x.setTime('end');
                });
            });
        }
    };
    VisitorCreateEventComponent.prototype.adjustForDaylightSaving = function (start, end, nextDayStart) {
        var formatter = EventTimeService.getTimezoneFormatterByTimezone(this.command.timezone);
        var startTimezone = EventTimeService.getTimezonecodeWithTimeSaving(start, formatter);
        var nextDayTimezone = EventTimeService.getTimezonecodeWithTimeSaving(nextDayStart, formatter);
        var thisEnd = end;
        if (startTimezone !== nextDayTimezone) {
            if (nextDayTimezone.indexOf('ST') >= 0) {
                nextDayStart = EventTimeService.addHours(nextDayStart, 1);
                thisEnd = EventTimeService.addHours(thisEnd, 1);
            }
            else {
                nextDayStart = EventTimeService.addHours(nextDayStart, -1);
                thisEnd = EventTimeService.addHours(thisEnd, -1);
            }
        }
        return {
            startTime: nextDayStart,
            endTime: thisEnd,
        };
    };
    VisitorCreateEventComponent.prototype.resetFrequencyDropdown = function () {
        this.frequencyItems = [
            {
                text: 'Custom',
                value: 'custom',
                selected: true,
            },
            {
                text: 'Daily',
                value: 'daily',
            },
            {
                text: 'Weekly',
                value: 'weekly',
            },
            {
                text: 'Biweekly',
                value: 'biweekly',
            },
            {
                text: 'Monthly',
                value: 'monthly',
            },
        ];
    };
    VisitorCreateEventComponent.prototype.setEventTimes = function (start, end, eventTimes) {
        var startTime = start;
        var endTime = new Date(new Date(startTime).setUTCHours(new Date(end).getUTCHours()));
        endTime = new Date(endTime.setUTCMinutes(new Date(end).getUTCMinutes()));
        if (endTime < new Date(startTime)) {
            endTime = new Date(EventTimeService.addHours(endTime, 24));
        }
        eventTimes.push({
            startTime: startTime,
            endTime: endTime.toISOString(),
        });
    };
    VisitorCreateEventComponent.prototype.setDefaultTimeValue = function () {
        var endPlusHours = 0;
        switch (this.command.frequency) {
            case 'custom':
                endPlusHours = 24 + 3;
                break;
            case 'daily':
                endPlusHours = 24 * 7 + 3;
                break;
            case 'weekly':
                endPlusHours = 24 * 365 + 3;
                break;
        }
        if (!this.command.eventTimes[0].startTime && !this.command.eventTimes[0].endTime) {
            this.command.eventTimes = [
                {
                    startTime: EventTimeService.getDefaultStartTime(this.command.timezone),
                    endTime: EventTimeService.addHours(EventTimeService.getDefaultStartTime(this.command.timezone), endPlusHours),
                },
            ];
        }
        else if (this.command.eventTimes[0].startTime && !this.command.eventTimes[0].endTime) {
            this.command.eventTimes = [
                {
                    startTime: this.command.eventTimes[0].startTime,
                    endTime: EventTimeService.addHours(new Date(this.command.eventTimes[0].startTime), 24 * 7),
                },
            ];
        }
        else if (!this.command.eventTimes[0].startTime && this.command.eventTimes[0].endTime) {
            this.command.eventTimes = [
                {
                    startTime: EventTimeService.addHours(new Date(this.command.eventTimes[0].startTime), 24 * 7 * -1),
                    endTime: this.command.eventTimes[0].endTime,
                },
            ];
        }
    };
    Object.defineProperty(VisitorCreateEventComponent.prototype, "addressInputLabel", {
        get: function () {
            if (!this.isAllowOnlineEvents) {
                return "Location / Address *";
            }
            return "Location / Address " + (this.command.isOnlineEvent ? '' : '*') + " (or check Virtual Events)";
        },
        enumerable: true,
        configurable: true
    });
    VisitorCreateEventComponent.prototype.setImageUploaderLabel2 = function () {
        var settingStorage = localStorage.getItem(localStorageKeys.visitorSettings);
        if (settingStorage) {
            this.visitorSettings = JSON.parse(settingStorage);
            if (this.visitorSettings.calendarStyle.event === 'square') {
                this.imageUploaderLabel2 = this.imageUploaderLabel2.replace('360px', '640px');
            }
            if (!isNullOrUndefined(this.visitorSettings.isAllowOnlineEvents)) {
                this.isAllowOnlineEvents = this.visitorSettings.isAllowOnlineEvents;
            }
        }
    };
    return VisitorCreateEventComponent;
}(BaseComponent));
export { VisitorCreateEventComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/create.event/create.event.component.ts.pre-build-optimizer.js